<div class="border border-1 border-gray-200 rounded-3xl px-4 py-8 w-full">
  <div class="flex flex-col md:flex-row justify-center w-full gap-8 md:pr-8 lg:pr-32">
    <ng-container *ngIf="requestStatus !== REQUEST_STATUS.Inprogress; else loader">
      <div class="w-full md:w-1/2 lg:w-2/4" *ngIf="requestStatus !== REQUEST_STATUS.Completed">
        <div class="border-2 border-dashed border-primary rounded-2xl p-6 md:p-10 w-full text-center poppins-medium upload-box"
          (dragover)="onDragOver($event)" (drop)="onFileDrop($event)">
          <p>
            <i class="pi pi-cloud-upload" style="font-size: 2rem; color: gray"></i>
          </p>
          <p>Drag and drop file(s) here</p>
          <p class="mt-2">- OR -</p>
          <p-fileUpload #fileUpload name="demo[]" mode="basic" chooseLabel="Browse Files" [pTooltip]="files.length > 0 ? 'You can\'t select more than one file' : 'Choose Files'" [disabled]="files.length > 0"
            tooltipPosition="bottom" accept=".xlsx,.xls,.xlsb" [auto]="true" [customUpload]="true" [multiple]="false"
            (onSelect)="onFileSelect($event)">
          </p-fileUpload>
          <p class="text-gray-500 pt-4 text-center">
            <small>Supported formats: XLSX, XLS, XLSB</small>
          </p>
        </div>
      </div>
    </ng-container>
    <ng-template #loader>
      <div class="w-full md:w-1/2 lg:w-2/4">
        <img src="/assets/images/loader.gif" class="rounded-xl w-full">
      </div>
    </ng-template>

    <div class="w-full md:w-1/2 lg:w-2/4">
      <div class="form-container">
        <form [formGroup]="fileUploadForm">
          <div class="px-4 md:px-8 py-4">
            <label for="name">Sheet Name</label>
            <input required id="name" type="text" pInputText formControlName="name" class="mt-2 w-full" />
            <div *ngIf="checkErrorMessage(fileUploadForm, 'name', isSubmitted())"
              class="text-red-500 text-sm mt-1">
              Record Name is required
            </div>
          </div>
          <div class="flex flex-col md:flex-row justify-between gap-4 px-4 md:px-8">
            <div class="w-full md:w-1/2">
              <label for="tolerance">Tolerance</label>
              <input required id="tolerance" type="number" [min]="0" pInputText formControlName="tolerance" class="mt-2 w-full" />
              <div *ngIf="checkErrorMessage(fileUploadForm, 'tolerance', isSubmitted())"
                class="text-red-500 text-sm mt-1">
                Invalid Tolerance
              </div>
            </div>
            <div class="w-full md:w-1/2">
              <label for="month">Month/ Year</label><br />
              <p-calendar styleClass="!mt-2 w-full" formControlName="month" view="month" dateFormat="mm/yy"
                [readonlyInput]="true" [showIcon]="true" required="true" />
              <div *ngIf="checkErrorMessage(fileUploadForm, 'month', isSubmitted())" class="text-red-500 text-sm mt-1">
                Please select a month
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="files-Section px-4 md:px-8 py-6">
        <h3 class="text-primary poppins-medium" *ngIf="files.length">Selected Files:</h3>
        <div class="px-3 py-3 text-gray-400" *ngFor="let file of files; let i = index">
          <div class="flex items-center gap-4">
            <i class="pi pi-file-excel" pTooltip="Excel" tooltipPosition="bottom"
              style="color: #5539a8; font-size: 1.5rem; text-decoration: none"></i>
            <small class="poppins-medium truncate max-w-[150px] block overflow-y-hidden whitespace-nowrap text-ellipsis"
              style="text-decoration: none" [title]="file.name">
              {{ file.name }}
            </small>
            <div class="ml-auto" *ngIf="requestStatus !== REQUEST_STATUS.Completed">
              <p-button icon="pi pi-times" [disabled]="requestStatus === REQUEST_STATUS.Inprogress" [rounded]="true"
                pTooltip="Remove File" tooltipPosition="bottom" [text]="true" severity="danger"
                (click)="removeFile(i)" />
            </div>
          </div>
          <p-divider *ngIf="files.length > 1" />
        </div>
        <div class="mt-4">
          <p-button label="Reset" [outlined]="true" (onClick)="reset.emit(true)" severity="danger"
            *ngIf="requestStatus === REQUEST_STATUS.Completed || requestStatus === REQUEST_STATUS.Error; else upload" styleClass="!w-full"></p-button>
          <ng-template #upload>
            <p-button label="Match Files" (onClick)="uploadFile()"
              [disabled]="files.length == 0 || !fileUploadForm.touched || fileUploadForm.invalid || requestStatus === REQUEST_STATUS.Inprogress"
              styleClass="!w-full"></p-button>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>